import React from 'react';

import '@eika/button-style';

import RemovableChip from './RemovableChip';
import ToggleChip from './ToggleChip';
import type { ChipComposition, ChipProps } from './types';

const Chip: React.FC<ChipProps> & ChipComposition = ({ ...rest }) => {
    return <ToggleChip {...rest} />;
};

Chip.Toggle = ToggleChip;
Chip.Removable = RemovableChip;

export default Chip;
